import * as React from "react"
import styled from "styled-components"
import { theme } from "../../theme"
import { CheckboxActive, CheckboxPassive } from "../icons/CheckboxIcons"

interface CheckboxProps {
  checked?: boolean
  faded?: boolean
  onChange?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  disabled?: boolean
  tabIndex?: number
}

const CheckboxContainer = styled.button<{ disabled?: boolean }>`
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};

  :hover {
    opacity: ${(props) => (props.disabled ? 1 : 0.7)};
  }
`

const Checkbox: React.FunctionComponent<CheckboxProps> = ({ faded, checked, onChange, disabled, tabIndex }) => {
  return (
    <CheckboxContainer
      disabled={disabled ?? faded}
      onClick={(event) => (disabled ? undefined : onChange?.(event))}
      tabIndex={tabIndex}
    >
      {checked ? (
        <CheckboxActive
          color={disabled ? theme.colors.greyDisabled : theme.colors.greyDark}
          opacity={faded ? "0.3" : "1"}
        />
      ) : (
        <CheckboxPassive
          color={disabled ? theme.colors.greyDisabled : theme.colors.greyDark}
          opacity={faded ? "0.3" : "1"}
        />
      )}
    </CheckboxContainer>
  )
}

export default Checkbox
